import { render } from "./TodoCardShowResumo.vue?vue&type=template&id=05e98808"
import script from "./TodoCardShowResumo.vue?vue&type=script&lang=js"
export * from "./TodoCardShowResumo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__